<template>
    <div class="card">
        <div class="px-4">
            <div class="mt-4 mb-2">
                <p class="mb-0 font-weight-bold">
                    {{ review.consumer.displayName }}
                </p>
                <div class="d-flex flex-row align-items-center">
                    <UIIcon
                        v-for="n in review.stars"
                        :key="n"
                        :name="['fas', 'star']"
                        :color="'#FACC0C'"
                        class="stars"
                    />
                    <p class="ml-2 mb-0 date-info small-text">
                        {{ formatDate(review.createdAt) }}
                    </p>
                </div>
            </div>
            <p class="cut-text">
                {{ review.content }}
            </p>
            <p class="trustpilot-info small-text">
                Posted on <br /><a href="https://www.trustpilot.com" target="_blank">Trustpilot</a>
            </p>
        </div>
    </div>
</template>

<script>
import { UIIcon } from '@dundle/ui/components';
export default {
    components: {
        UIIcon,
    },
    props: {
        review: {
            type: Object,
            required: true,
        },
    },
    methods: {
        formatDate(date) {
            const now = new Date().getDate();
            if (now - date === 1) {
                return 'Yesterday';
            } else if (now - date === 2) {
                return 'Two days ago';
            }
            return date.split('T')[0];
        },
    },
};
</script>

<style lang="scss" scoped>
.card {
    background-color: $color-bg;
    width: 75%;
    height: 17.5rem;

    border-radius: $border-radius-default;
    box-shadow: 10px 10px 40px rgba(0, 0, 0, 0.3);

    @media screen and (min-width: 768px) {
        height: 13.4rem;
        max-width: 20rem;
    }
}

.trustpilot-info {
    position: absolute;
    bottom: 1rem;
    line-height: 1.2rem;
}

.date-info {
    position: relative;
    top: 1px;
}

.small-text {
    font-size: 0.8rem;
    color: $color-text;
}

.cut-text {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
